import { useAnytimeSupportContract } from "@/api/services/main/any-time/support-contract";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { AnytimeSupportContractDetailPage } from "@/features/anytime/pages/documents/AnytimeSupportContractDetail";
import { convertResDtoToFormData } from "@/features/anytime/utils/support-scontract";

const AnytimeSupportContractDetail = () => {
  const { data: supportContractResult, isLoading } = useAnytimeSupportContract();
  const supportContractData = supportContractResult?.data;

  if (isLoading || !supportContractData) return <LoadingPage />;

  return <AnytimeSupportContractDetailPage defaultValues={convertResDtoToFormData(supportContractData)} />;
};

export default AnytimeSupportContractDetail;
